var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-login"},[_c('ShowGift',{attrs:{"isGift":_vm.isGift,"newUserData":_vm.newUserData},on:{"closeNewUser":_vm.closeNewUser}}),(_vm.isYearTabBox)?_c('ChooseRecords',{on:{"closeChooesRecords":_vm.closeYearBox}}):_vm._e(),_c('RegisterAfter',{ref:"registerAfter",on:{"closeRegisterAfter":_vm.closeRegisterAfter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }